import { HttpErrorResponse } from '@angular/common/http';
import { Component, NgZone, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { Router } from '@angular/router';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { isNullOrUndefined } from 'util';
import { ConfigDetails } from '../../../../models/appConfig.model';
import { CLPUser, UserResponse } from '../../../../models/clpuser.model';
import { ContactList, ContactRestore } from '../../../../models/contact.model';
import { eFeatures, eUserRole } from '../../../../models/enum.model';
import { SimpleResponse } from '../../../../models/genericResponse.model';
import { RoleFeaturePermissions } from '../../../../models/roleContainer.model';
import { SearchQueryResponse } from '../../../../models/search.model';
import { ContactService } from '../../../../services/contact.service';
import { NotificationService } from '../../../../services/notification.service';
import { AppconfigService } from '../../../../services/shared/appconfig.service';
import { ContactCommonSearchService } from '../../../../services/shared/contact-common-search.service';
import { GridConfigurationService } from '../../../../services/shared/gridConfiguration.service';
import { LocalService } from '../../../../services/shared/local.service';
import { UtilityService } from '../../../../services/shared/utility.service';
import { process } from '@progress/kendo-data-query';
import { GlobalService } from '../../../../services/global.service';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
declare var $: any;

@Component({
    selector: 'contact-archive',
    templateUrl: './contact-archive.component.html',
    styleUrls: ['./contact-archive.component.css'],
    providers: [GridConfigurationService, ContactCommonSearchService]
})

export class ContactArchiveComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();
    private intervals = new Set<ReturnType<typeof setInterval>>();

    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    contactsArchiveDataSource: MatTableDataSource<any>;
    contactsArchiveDataDisplayColumns: string[] = [];
    showSpinner: boolean = false;
    private encryptedUser: string = '';
    user: CLPUser;
    userResponse: UserResponse;
    roleFeaturePermissions: RoleFeaturePermissions;
    contactsArchiveData: ContactList[] = [];
    initContactsArchiveData: ContactList[];
    dateFormat: string;

    columns = [
        { field: '$', title: ' ', /*width: '40'*/ },
        { field: '$$', title: '  ', /*width: '40'*/ },
        { field: 'name', title: 'Name', /*width: '250'*/ },
        { field: 'email', title: 'Email', /*width: '70'*/ },
        { field: 'title', title: 'Title', /*width: '90'*/ },
        { field: 'companyName', title: 'Company', /*width: '350'*/ },
        //{ field: 'address', title: 'Address', width: '120' },
        //{ field: 'city', title: 'City', width: '80' },
        //{ field: 'state', title: 'State', width: '80' },
        //{ field: 'country', title: 'Country', width: '80' },
        //{ field: 'zip', title: 'Zip', width: '60' },
        //{ field: 'emailAddress', title: 'Email Address', width: '140' },
        { field: 'phone', title: 'Phone', /*width: '120'*/ },
        { field: 'userName', title: 'User', /*width: '120'*/ },
        { field: 'dtModifiedDisplay', title: 'Modified', /*width: '100'*/ },
        { field: 'dtCreatedDisplay', title: 'Created', /*width: '90'*/ },
        { field: 'dtArchive', title: 'Deleted', /*width: '90'*/ },
        { field: 'deleteNote', title: 'Note', /*width: '90'*/ },
        { field: 'action', title: '', /*width: '90' */ },
    ];
    reorderColumnName: string = 'name,email,title,companyName,phone,userName,dtModifiedDisplay,dtCreatedDisplay,dtArchive,deleteNote';
    columnWidth: string = 'name:250,email:70,title:100,companyName:350,phone:120,userName:120,dtModifiedDisplay:100,dtCreatedDisplay:90,dtArchive:90,deleteNote:190';
    arrColumnWidth: any[] = ['name:250,email:70,title:100,companyName:350,phone:120,userName:120,dtModifiedDisplay:100,dtCreatedDisplay:90,dtArchive:90,deleteNote:190'];
    @ViewChild(DataBindingDirective) dataBinding: DataBindingDirective;

    public mySelection: number[] = [];
    step = 1;
    gridHeight;
    engageUrl: any;
    queryDataLoaded: SearchQueryResponse;
    restoreAllContacts: boolean = false;


    sendMail: any = { isShow: false, contactId: 0 };
    mobileColumnNames: string[];
    isConfirmRestore: boolean = false;
    contactsCountAll: number = 0;

    constructor(public _localService: LocalService,
        private _utilityService: UtilityService,
        private _notifyService: NotificationService,
        private _contactCommonSearchService: ContactCommonSearchService,
        private _ngZone: NgZone,
        private _appConfigService: AppconfigService,
        private _router: Router,
        public _gridCnfgService: GridConfigurationService,
        public _globalService: GlobalService,
        public _contactService: ContactService
    ) {
        this._localService.isMenu = true;
        this.subscribeToEvents();
    }

    ngOnInit() {
        this._globalService.getToken((token) => {
            if (token) {
                this.encryptedUser = token;
                this.authenticateR().then(() => {
                    if (this.user) {
                        this.getEngageSite();
                        //Kendo grid load call stopped.
                    }
                    else
                        this._router.navigate(['/login']);

                });
            }
            else
                this._router.navigate(['/login']);
        });
    }

    getEngageSite() {
        this.engageUrl = localStorage.getItem('Engage_Site') ? localStorage.getItem('Engage_Site') : null;
        if (this.engageUrl == null) {
            this._appConfigService.getAppConfigValue(this.encryptedUser, "Engage_Site")
                .then(async (result: ConfigDetails) => {
                    this.engageUrl = result?.configValue;
                });
        }
    }

    private async authenticateR() {
        this.showSpinner = true;
        await this._localService.authenticateUser(this.encryptedUser, eFeatures.RestoreContacts)
            .then(async (result: UserResponse) => {
                if (result) {
                    await this._localService.checkIfExpiredOrUnauthorized(result?.user);
                    this.userResponse = UtilityService.clone(result);
                    this.dateFormat = this.userResponse.user.dateFormat;
                    if (!isNullOrUndefined(this.userResponse)) {
                        if (!isNullOrUndefined(this.userResponse?.user)) {
                            this.user = this.userResponse.user;
                            this.roleFeaturePermissions = this.userResponse.roleFeaturePermissions;
                            if (this.user?.userRole <= eUserRole.Administrator) {
                                if (this.roleFeaturePermissions?.view == false)
                                    this._router.navigate(['/unauthorized'], { state: { isMenu: true } });
                            }
                        }
                    }
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false;
                this._globalService.error("contact-archive.authenticateR", err.message, null,
                    'Features: ' + eFeatures.RestoreContacts
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    setTotalContactCount(event: number) {
        this.contactsCountAll = event;
    }

    private subscribeToEvents(): void {
        this._contactCommonSearchService.contactListChanged.pipe(takeUntil(this.destroy$)).subscribe((data) => {
            this._ngZone.run(() => {
                this.contactsArchiveData = data;
                if (this.contactsArchiveData.length > 0) {
                    this.setGrid(this.contactsArchiveData);
                }
                else {
                    this.contactsArchiveData = [];
                    this.contactsArchiveDataDisplayColumns = [];
                    this.contactsArchiveDataSource = new MatTableDataSource([]);
                }
                this.initContactsArchiveData = data;
                this.step = 2;
                this.restoreAllContacts = false;
            })
        });
        this._contactCommonSearchService.queryListChanged.pipe(takeUntil(this.destroy$)).subscribe((data) => {
            this._ngZone.run(() => {
                this.queryDataLoaded = data;
                this.step = 2;
                this.restoreAllContacts = false;
            })
        });
        this._contactCommonSearchService.contactCountChanged.pipe(takeUntil(this.destroy$)).subscribe((data) => {
            this._ngZone.run(() => {
                this.contactsCountAll = data;
            })
        });
    }

    showColumn(columnDef): boolean {
        var value = true;
        if (columnDef) {
            (columnDef == 'email') || (columnDef == 'phone') ? value = false : value = true;
        }
        return value;
    }

    gotoLink(columnName, dataItem) {
        var url = this.engageUrl;
        if (columnName) {
            switch (columnName) {
                case "address-card":
                case "name": {
                    if (this.user.timeZoneWinId != 0) {
                        let url = '/contact/' + dataItem.contactID;
                        return url;
                    }
                    else {
                        if (confirm("First , Please select your timezone!!!"))
                            this._router.navigate(['/edit-profile', dataItem.clpUserId]);
                        else
                            return;
                    }
                    break;
                }
                case "userName": {
                    return `/edit-profile/${dataItem.clpUserId}`;
                }
                case "email": {
                    $('#sendEmail').modal('show');
                    this.sendMail.isShow = true;
                    this.sendMail.contactId = dataItem?.contactID;
                    break;
                }
                default: {
                    break;
                }
            }
        }
    }

    getArchiveContacts() {
        if (!isNullOrUndefined(this._gridCnfgService)) {
            this.mobileColumnNames = this._gridCnfgService.getResponsiveGridColums('contact_restore_grid');
            this._gridCnfgService.iterateConfigGrid(true, "contact_restore_grid");
        }

    }

    restoreContacts() {
        if (this.restoreAllContacts) {
            if (!isNullOrUndefined(this.queryDataLoaded)) {
                let contactRestoreSelected: ContactRestore = <ContactRestore>{};
                contactRestoreSelected.isRestoreAll = true;
                contactRestoreSelected.contactsToRestore = [];
                contactRestoreSelected.searchQuery = this.queryDataLoaded;
                this.restoreContactApi(contactRestoreSelected);
            }
            else {
                this._notifyService.showError('Could not find the Searched Data', 'Please Try again');
            }
        }
        else {
            let contactRestoreSelected: ContactRestore = <ContactRestore>{};
            contactRestoreSelected.isRestoreAll = false;
            contactRestoreSelected.contactsToRestore = this.mySelection;
            contactRestoreSelected.searchQuery = null;
            this.restoreContactApi(contactRestoreSelected);
        }

    }

    async restoreContactApi(restoreContact: ContactRestore) {
        this.showSpinner = true;

        await this._contactService.restoreContacts(this.encryptedUser, restoreContact, this.user.cLPCompanyID, this.user.cLPUserID)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    this.step = 1;
                    this._notifyService.showSuccess(result.messageString, 'Contact Restore Successful', 4000);
                    this.showSpinner = false;
                    this.restoreAllContacts = false;
                    this.contactsArchiveData = [];
                    this.mySelection = [];
                    this.isConfirmRestore = false;
                }
                else {
                    this.showSpinner = false;
                    this.restoreAllContacts = false;
                    this.contactsArchiveData = [];
                    this.mySelection = [];
                    this.isConfirmRestore = false;
                }

            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-archive.restoreContactApi", err.message, restoreContact,
                    'this.user.cLPCompanyID: ' + this.user.cLPCompanyID
                    + 'cLPUserID: ' + this.user.cLPUserID
                );
                this._utilityService.handleErrorResponse(err);
                this.showSpinner = false;
                this.restoreAllContacts = false;
                this.contactsArchiveData = [];
                this.mySelection = [];
                this._notifyService.showError('Could not Archived selected Data', 'Some Error Occured');
                this.step = 2;
            });
    }

    cancelArchive() {
        this.step = 1;
        this.restoreAllContacts = false;
        this.contactsArchiveData = [];
        this.initContactsArchiveData = [];
        this.setGrid(this.contactsArchiveData);
        this.mySelection = [];
    }

    onContactArchiveListFilter(inputValue: string): void {
        inputValue = inputValue.trim().toLowerCase();

        if (this.contactsArchiveDataSource) {
            this.contactsArchiveDataSource.filterPredicate = (data: any, filter: string) => {
                return Object.keys(data).some((key) => {
                    return data[key]?.toString().toLowerCase().includes(filter);
                });
            };

            this.contactsArchiveDataSource.filter = inputValue;
        }
    }


    setGrid(list) {
        this.contactsArchiveDataDisplayColumns = this.columns.map(c => c.field);
        this.contactsArchiveDataSource = new MatTableDataSource(list);
        this.addTimeout(() => {
            this.contactsArchiveDataSource.paginator = this.paginator;
            if (this.paginator) {
                this.paginator.pageSize = this._localService.getPageSize('contact_restore_grid') ? this._localService.getPageSize('contact_restore_grid') : 50;
            }
            if (this.sort) {
                this.contactsArchiveDataSource.sort = this.sort;
                const sortState: Sort = this._localService.getSortState('contact_restore_grid');
                this.sort.active = sortState?.active;
                this.sort.direction = sortState?.direction;
                this.sort.sortChange.emit(sortState);
            }
        }, 500);
    }

    getSerialNumber(index: number): number {
        return index + 1 + (this.paginator?.pageIndex || 0) * (this.paginator?.pageSize || 5);
    }

    toggleSelection(row) {
        const index = this.mySelection.findIndex(r => r == row.contactID);
        if (index >= 0) {
            this.mySelection.splice(index, 1);
        } else {
            this.mySelection.push(row.contactID);
        }
    }

    isSelected(row): boolean {
        return this.mySelection.includes(row);
    }

    toggleSelectAll(event: any) {
        if (event.checked) {
            this.mySelection = [...this.contactsArchiveDataSource.data];
        } else {
            this.mySelection = [];
        }
    }

    isAllSelected(): boolean {
        if (this.mySelection && this.contactsArchiveDataSource && this.contactsArchiveDataSource.data.length > 0) {
            return this.mySelection.length == this.contactsArchiveDataSource.data.length;
        }
        return false;
    }

    isIndeterminate(): boolean {
        return this.mySelection.length > 0 && !this.isAllSelected();
    }

    private timeouts = new Set<ReturnType<typeof setTimeout>>();
    addTimeout(callback, timeout) {
        const id = setTimeout(() => {
            if (callback) {
                callback();
            }
            this.timeouts.delete(id);
        }, timeout);
        this.timeouts.add(id);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();

        this.timeouts.forEach(id => clearTimeout(id));
        this.timeouts.clear();

        this.intervals.forEach(id => clearInterval(id));
        this.intervals.clear();
    }

    hideSendMail() {
        $('#sendEmail').modal('hide');
        this.sendMail.isShow = false;
        this.sendMail.contactId = 0;
    }

    onRestoreConfirm() {
        if (!this.isConfirmRestore) {
            this.isConfirmRestore = true;
            return;
        }

        this.restoreContacts();
        this.isConfirmRestore = false;
    }
}
